module.exports = __webpack_public_path__ + "static/media/as1cr0.abf86456.png";